module.exports = __webpack_public_path__ + "static/media/photo-1.95e5a1a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-threshing-barn/photo-1.jpg
// module id = 160
// module chunks = 0